import { Col, Form, Row, Typography } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";
import useMazakaForm from "hooks/useMazakaForm";

const SendRequest = () => {
  const { Text } = Typography;
const [form] = Form.useForm();
const { formActions, mazakaForm } = useMazakaForm(form,{submitText:"Gönder"});
  return (
    <>
      <Col xs={24}>
        <MazakaForm {...formActions} >
          <Row>
          
            <MazakaTextArea
              label="Açıklama"
              placeholder="Açıklama"
              xs={24}
            />

           
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default SendRequest;
